import {
  SchedulesSearchProcedure,
  SearchPartnerData,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { CartItem, CartItemBody } from '@/types/cart.types';

export const SLOT_ALREADY_IN_CART_MESSAGE = 'Esse horário já está no seu carrinho.';

export function getOfferedProcedures(schedule: SearchPartnerData): SchedulesSearchProcedure[] {
  return schedule.procedures.filter((procedure) => procedure.isAvailable);
}

export function getCartItemsOfSlot(
  items: CartItem[],
  partnerFacilityId: string,
  slotId: string,
): CartItem[] {
  return items.filter(
    (item) => item.partner.facility.id === partnerFacilityId && item.slot.id === slotId,
  );
}

export function buildSlotCartItems(
  schedule: SearchPartnerData,
  patientId: string,
  slotId: string,
): CartItemBody[] {
  return getOfferedProcedures(schedule)
    .map((procedure) => ({
      procedureId: procedure.id,
      patientId,
      partnerFacilityId: schedule.partner.facility.id,
      professionalId: schedule.professional?.id || undefined,
      promotionId: procedure.promotionId,
      slotId,
    }));
}
